import { FileData, convertApis } from "Api/index";
import { TASK_STATUS, DATA_TYPE } from "Api/constants";
import {
    downloadFileWithUrl,
  } from 'Api/drives.api';

// function ConvertTask(params) {
//     this.lists = {
//         upload: [],     // single file or multi-files
//         convert: [],    // with password, need redo when use input password
//         monitor: []     //
//     }
//     // ToDo
//     // this.type = type;
//     // this.isAuto = true;
//     // this.step = 0;
//
// }

// upload 
// convert
// const callbacks = [
//     'doUpload',// convertApis.doUpload
//     'doConvert',
//     'doMonitorStatus'
// ];
/**
 * let task = new Task(fileData, convertType, ()=>{
            let args = arguments;
            let cbs = [...callbacks];
            let key =  cbs.shift(); 
            convertApis[key](args);
        },(result)=>{

        })
 */

export class PDFConvertService{
    constructor(){
        this.doGetCloudDriveFileBuffer = this.doGetCloudDriveFileBuffer.bind(this);
        this.doUpload = this.doUpload.bind(this);
    }

    doGetCloudDriveFileBuffer(fileData, dataType, fileId, modified){
        const {driveName,item} = fileData.file;
        return new Promise((resolve, reject) => {
            downloadFileWithUrl(
                driveName,
                item,
                ({ blob, /*id,*/ fileName }) => {
                    let file
                    let _fileData
                    blob.name = fileName

                    if (dataType === DATA_TYPE.File) {
                        file = new File([blob], fileName, {type: item.file.mimeType})
                        _fileData = new FileData(file, fileName, dataType || DATA_TYPE.FileBuffer, '', fileId || 0, modified);
                    } else {
                        _fileData = new FileData(blob, fileName, dataType || DATA_TYPE.FileBuffer, '', fileId || 0, modified);
                    }
                    resolve(_fileData);
                },
                (error) => {
                    reject({ error });
                },
            );
        })
    }
    /**
     * @param {FileData} fileData
     *
     * @param {Function} onUploadCallback
     * @param {Function} cancelCallback
     * @memberof PDFConvertService
     */
    async doUpload(fileData, onUploadCallback, cancelCallback){
        if( fileData.dataType === DATA_TYPE.File || 
            fileData.dataType === DATA_TYPE.FileBuffer){
            let result = await convertApis.doUpload(fileData, onUploadCallback, cancelCallback);
            return result;
        }
        if( fileData.dataType === DATA_TYPE.Cloud ){
            //let fileData = new FileData({driveName,item}, file.name, DATA_TYPE.Cloud, '', 0);
            //const {driveName,item} = fileData.file;
            let output = await this.doGetCloudDriveFileBuffer(fileData);
            if(!output.file){
                return output;
            }
            output = await convertApis.doUpload(output, onUploadCallback, cancelCallback);
            return output;
        }
        
    }

    doConvert = async (fileList, type, cfg, callback, error)=>{
        let result = await convertApis.doConvert(fileList, type, cfg);
        if(result.ret !== 0){
            error && error(result);
            return;
        }
        //"{"ret":0,"msg":"SUCCESS","data":{"taskid":"9c748722-cea8-4d0d-8018-9f14dd76b108"}}"
        const {taskid} = result.data;
        result.status = TASK_STATUS.MINOTOR;
        callback && callback(result);
        convertApis.doMonitorStatus(taskid, (res)=>{
            callback && callback(res)
        })
    }

    doDownloadMultiFile = (fileList, returnBlob)=>{
        let docIdArr=[];
        fileList.map((item)=>{
            item.id&&docIdArr.push([item.id,`${item.bookmark}.pdf`])
        })
        
        return convertApis.doDownloadZipPost(docIdArr, returnBlob);
    }
    /*addTask = () =>{
        
    }*/
}